import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../../button/button';
import { NextIcon } from '../../icons/icons';
import AccordionPanel from '../../accordion-panel/accordion-panel';
import BesicTable from '../../table/basicTable';
import {
  ConsolidatedMaterialsColumns,
  CustomsEntriesColumns,
} from '../../../schema/bookingColumns';

function ConsolidatedPkgDetailsTab({
  setSupplierTab,
  materialsInfo,
  customEntries,
  setTabDetails,
}) {
  const [t] = useTranslation('manageorders');

  const materialsColumns = ConsolidatedMaterialsColumns();
  const entriesColumns = CustomsEntriesColumns();

  return (
    <div className="supplier-booking-content">
      <div className="d-flex justify-between align-center">
        <h3>{t('manageordersscreen.bookingdetailsbtn.bookingTitle')}</h3>
      </div>
      {materialsInfo?.length ? (
        <AccordionPanel
          //   title={t('manageordersscreen.bookingdetailsbtn.addpackage')}
          title={t(
            'manageordersscreen.bookingdetailsbtn.consolidatedMaterials'
          )}
        >
          <BesicTable
            columns={materialsColumns}
            data={materialsInfo}
            className="supplier-booking auto-column-width"
          />
        </AccordionPanel>
      ) : null}

      {customEntries?.length ? (
        <AccordionPanel title="Custom Entries">
          <BesicTable
            columns={entriesColumns}
            data={customEntries}
            className="supplier-booking auto-column-width"
          />
        </AccordionPanel>
      ) : null}

      <div className="supplier-booking-button-area">
        <Button
          label={t('manageordersscreen.bookingdetailsbtn.next')}
          styles="submit"
          size="large"
          className="px-24"
          onClick={() => {
            setTabDetails((prev) => {
              const updatedTabDetails = { ...prev };
              updatedTabDetails.consolidatedPkgDetails = true;
              return updatedTabDetails;
            });
            setSupplierTab('shipment details');
          }}
          iconRight={<NextIcon />}
          spacing="0.694vw"
        />
      </div>
    </div>
  );
}

export default React.memo(ConsolidatedPkgDetailsTab);
ConsolidatedPkgDetailsTab.propTypes = {
  setSupplierTab: PropTypes.func,
  materialsInfo: PropTypes.instanceOf(Array),
  customEntries: PropTypes.instanceOf(Array),
  setTabDetails: PropTypes.func,
};
ConsolidatedPkgDetailsTab.defaultProps = {
  setSupplierTab: () => {},
  materialsInfo: [],
  customEntries: [],
  setTabDetails: () => {},
};
